import type { ComponentProps } from 'react';

const Dashboard = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5 4.875C19.8438 4.875 20.125 5.15625 20.125 5.5V8H3.875V5.5C3.875 5.15625 4.15625 4.875 4.5 4.875H19.5ZM3.875 18V9.875H7.625V18.625H4.5C4.15625 18.625 3.875 18.3438 3.875 18ZM9.5 18.625V9.875H20.125V18C20.125 18.3438 19.8438 18.625 19.5 18.625H9.5ZM4.5 3C3.12109 3 2 4.12109 2 5.5V18C2 19.3789 3.12109 20.5 4.5 20.5H19.5C20.8789 20.5 22 19.3789 22 18V5.5C22 4.12109 20.8789 3 19.5 3H4.5Z"
        fill="#55657D"
      />
    </svg>
  );
};

export default Dashboard;
